import { SecurityTeamList } from "./SecurityTeamList";

export default SecurityTeamList;
